export default function fixEnum(value:any, enumType:any) {
    if(!value) {
        return value;
    }

    if(typeof(value) !== "string") {
        return value;
    }

    let valueKey = value.toString();
    if(enumType[valueKey] === undefined) {
        valueKey = valueKey.charAt(0).toUpperCase() + valueKey.slice(1);
    }

    return enumType[(valueKey as any)] as any;
}